<script setup lang="ts">
import type { IDrawerAccordionProps } from '../types'

const props = defineProps<IDrawerAccordionProps>()

function toggleAccordionItem(accordionItem: any, isOpen: boolean) {
    accordionItem.isOpen = isOpen
}
</script>

<template>
    <section>
        <VDivider
            v-if="props.topDivider"
            class="mb-2"
        />

        <VAccordionItem
            v-for="(accordionItem, index) in props.items"
            :key="`accordion_item_faq_${index}`"
            v-model:is-open="accordionItem.isOpen"
            :data-test="`accordion_item_faq_${index}`"
            :item="{
                value: accordionItem.title || 'empty-value',
                title: accordionItem.title,
                isOpen: !!accordionItem.isOpen,
            }"
            :icon="accordionItem.icon"
            size="SMALL"
            :hide-divider="props.items && index === props.items?.length - 1"
            @update:is-open="toggleAccordionItem(accordionItem, $event)"
        >
            <div v-html-gpp="accordionItem.content" />
        </VAccordionItem>
    </section>
</template>
